import config from "@/config";
import http from "@/utils/request";

export default {
	medalCategory: {
		list: {
			url: `${config.API_URL}/admin/medal_category/getList`,
			name: "获取勋章分类列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/medal_category/detail`,
			name: "获取勋章分类详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/medal_category/create`,
			name: "创建勋章分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/medal_category/update`,
			name: "更新勋章分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/medal_category/delete`,
			name: "删除勋章分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	medal: {
		list: {
			url: `${config.API_URL}/admin/medal/getList`,
			name: "获取勋章列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/medal/detail`,
			name: "获取勋章详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		create: {
			url: `${config.API_URL}/admin/medal/create`,
			name: "创建勋章",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/medal/update`,
			name: "更新勋章",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/medal/delete`,
			name: "删除勋章",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateStatus: {
			url: `${config.API_URL}/admin/medal/updateStatus`,
			name: "更新勋章状态",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		conditionTypes: {
			url: `${config.API_URL}/admin/task/getConditionTypes`,
			name: "获取条件类型列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
	},
};
